import React from 'react'
import ViewMenuItem from './ViewMenuItem'
import { ToggleModal, ModalView } from 'components/Modal'

type Props = React.ComponentProps<typeof ViewMenuItem> & {
  modal: React.ReactNode;
}

const ViewMenuModalItem: React.FC<Props> = ({
  modal,
  ...props
}) => {
  return (
    <ToggleModal
      attachment='top center'
      targetAttachment='bottom center'
      constraints={[
        {
          to: 'window',
          pin: true
        }
      ]}
    >
      <ViewMenuItem
        {...props}
      />
      <ModalView>
        {modal}
      </ModalView>
    </ToggleModal>
  )
}

export default ViewMenuModalItem
